(ns app.front.view.workspace.ecm-sync-on-finished
  (:require [app.front.ui.error-boundary :as eb]
            [app.front.view.workspace.subs :as ws-subs]
            [core.db.entity.util :as eu]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]))

(defn ecm-sync-confirm
  "Allow user to select whether to send the content package to ECM when finishing."
  [{:keys [tr process-target]}]
  [eb/error-boundary
   (when-let [system-name (and (<sub [::ws-subs/has-feature? :group.feature/ecm-integration])
                               ;; ECM not included in pre-con states' entries, see WIN-3758
                               (not (eu/is-type? :entity.type/pre-consultation process-target))
                               ;; Will check that it is also configured
                               (<sub [::ws-subs/ecm-system-name]))]
     (let [checked (-> (<sub [:app.front.view.workspace.primary-actions/confirm-signal-parameters])
                       :skip-sync-to-ecm-system?
                       not)]
       [:<>
        (cc/checkbox
          {:id         "ecm-sync-on-finished-checkbox"
           :class-name "mb-4"
           :checked    checked
           :label-text (tr [:process.signal/sync-ws-package-to-ecm-system]
                           [system-name])
           :on-change  #(>evt [:app.front.view.workspace.primary-actions/set-confirm-signal-parameters
                               {:skip-sync-to-ecm-system? (not %)}])})]))])
